/* istanbul ignore file */
/** Still in development */
import { injectAvailableLanguages } from '@lumapps/customer/transforms';
import { injectInstanceFromWindow } from '@lumapps/instance/transforms';
import { injectLocale } from '@lumapps/translations/transforms';
import { initConnectedUser } from '@lumapps/user/transforms';

const keysToIgnore = ['content'];

const transforms = [injectInstanceFromWindow, injectLocale, initConnectedUser, injectAvailableLanguages];

export { transforms, keysToIgnore };
